module.exports = __webpack_public_path__ + "static/media/firebase-auth-logo.af4b567c.png";